module.exports = __webpack_public_path__ + "img/3-2.90c79fc0.png";